import React from 'react'
import styles from './styles.module.css'
import Img from '../../Img'
import Text from '../../Text'

// Portable-text customImage embed. `image` arrives as a pre-resolved
// ResolvedImage descriptor (task #67 content walker), rendered via canonical <Img>.
function ImageEmbed({ image, alt, caption }) {
  if (!image || !image.src) return null
  return (
    <div className={styles.wrapper}>
      <div className={[styles.imageWrapper, caption ? styles.imageWrapperHasCaption : null].filter(Boolean).join(' ')}>
        <Img image={image} alt={alt || image.alt} layout="responsive" objectFit="contain" />
      </div>
      {caption && (
        <div className={styles.caption}>
          <Text type="medium">{caption}</Text>
        </div>
      )}
    </div>
  )
}

export default ImageEmbed
